import { EyeSlashIcon } from "@heroicons/react/24/outline";

type ActiveTableFilterProps = {
  children: React.ReactNode;
  clearLabel: string;
  onClear?: () => void;
};

export const ActiveTableFilter = ({ children, clearLabel, onClear }: ActiveTableFilterProps) => {
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 border-b border-gray-100 pb-3">
      <p className="text-sm text-gray-600">{children}</p>
      {onClear && (
        <button
          type="button"
          onClick={onClear}
          className="inline-flex items-center gap-1.5 text-sm font-medium text-gray-500 hover:text-gray-800 focus:outline-none focus:ring-2 focus:ring-brand-500 focus:ring-offset-1 rounded"
        >
          <EyeSlashIcon className="w-4 h-4" />
          {clearLabel}
        </button>
      )}
    </div>
  );
}
